import {
  createDecimalExtension,
  createBooleanExtension,
} from '../unsw-fhir/Extension/helpers';

const customHostUrl = 'ihealthe.org';

export const createCriSTALValueExtension = (value: number) =>
  createDecimalExtension(`${customHostUrl}/cristalValue`, value);

export const createCriSTALHasAnswerExtension = (value: number) =>
  createDecimalExtension(`${customHostUrl}/cristalHasAnswer`, value);

export const createCriSTALGreaterOneExtension = (value: number) =>
  createDecimalExtension(`${customHostUrl}/cristalValueGreaterOne`, value);

export const createCriSTALOver65Extension = (flag: boolean) =>
  createBooleanExtension(`${customHostUrl}/cristalOver65`, flag);

export const cristalValueExtension = createCriSTALValueExtension(-1);
export const cristalHasAnswerExtension = createCriSTALHasAnswerExtension(-1);
export const cristalGreaterOneExtension = createCriSTALGreaterOneExtension(-1);
export const cristalOver65Extension = createCriSTALOver65Extension(false);
